import ComponentLayout from "../../../../src/layouts/component-layout";
import { ImageBorderRadiusOptions } from '@primer/react-brand';
import { Label } from '@primer/react';
import * as React from 'react';
export default {
  ComponentLayout,
  ImageBorderRadiusOptions,
  Label,
  React
};